import React from 'react'
import {GatsbyImage, getImage} from 'gatsby-plugin-image'
import parse from 'html-react-parser'
import Fade from 'react-reveal/Fade'

const FeaturedImage = ({image, rightPosition, showCaption}) => {

  return (
    <section className="featured-image">
      <div className="featured-image__inner">
        <Fade distance='40px' bottom>
          <div className={`featured-image__wrapper ${rightPosition ? 'content-right' : ''}`}>
            <GatsbyImage image={getImage(image.localFile)} alt={image.altText}/>
            {
              showCaption &&
              <div className="featured-image__cap">
                <h3>{image.altText}</h3>

                {parse(image.caption)}
              </div>
            }
          </div>
        </Fade>
      </div>
    </section>
  );
};

export default FeaturedImage